/* Divine Hindu — "Worth a watch" video row (sections/dh-video-reel.liquid), Oct 2026.
   A video plays muted while most of it is on screen and pauses when it leaves; only one plays at a time.
   Sound, play/pause and the seek bar sit on the video. A video the shopper paused stays paused until they play it.
   The video file is only attached when its card comes near the screen (480p on phones, 720p on larger screens). */
(function () {
  if (window.__dvrReady) return;
  window.__dvrReady = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var all = [];

  function fmt(t) {
    t = Math.max(0, Math.floor(t || 0));
    var m = Math.floor(t / 60), s = t % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  function pickSrc(v) {
    var wide = window.innerWidth >= 750;
    return (wide ? v.getAttribute('data-hd') : v.getAttribute('data-sd')) || v.getAttribute('data-hd') || v.getAttribute('data-sd') || '';
  }
  function attach(c) {
    if (c.loaded) return;
    var src = pickSrc(c.v);
    if (!src) return;
    c.loaded = true;
    c.v.src = src;
    c.v.preload = 'metadata';
  }
  function showCtl(c, ms) {
    c.m.classList.add('is-ctl');
    clearTimeout(c.ctlT);
    if (!c.v.paused) c.ctlT = setTimeout(function () { c.m.classList.remove('is-ctl'); }, ms || 2600);
  }
  function play(c, byUser) {
    attach(c);
    all.forEach(function (o) { if (o !== c && !o.v.paused) { o.v.pause(); } });
    var p = c.v.play();
    if (p && p.catch) p.catch(function () { c.m.classList.remove('is-playing'); });
    if (byUser) { c.userPaused = false; showCtl(c, 1800); }
  }
  function pause(c, byUser) {
    c.v.pause();
    if (byUser) { c.userPaused = true; c.m.classList.add('is-ctl'); clearTimeout(c.ctlT); }
  }
  function updateSound(c) {
    c.snd.setAttribute('aria-pressed', c.v.muted ? 'false' : 'true');
    c.snd.setAttribute('aria-label', c.snd.getAttribute(c.v.muted ? 'data-sound-on-label' : 'data-sound-off-label'));
  }
  function paint(c) {
    var d = c.v.duration, t = c.v.currentTime;
    var pct = d > 0 ? (t / d) * 100 : 0;
    if (!c.seeking) { c.seek.value = Math.round(pct * 10); }
    c.seek.style.setProperty('--p', pct + '%');
    c.time.textContent = fmt(t);
  }
  function setup(sec) {
    if (!sec || sec.__dvr) return;
    sec.__dvr = true;
    var rail = sec.querySelector('[data-dvr-rail]');
    var cards = [].slice.call(sec.querySelectorAll('[data-dvr-media]')).map(function (m) {
      return { m: m, v: m.querySelector('video'), snd: m.querySelector('[data-dvr-snd]'), pp: m.querySelector('[data-dvr-pp]'),
               seek: m.querySelector('[data-dvr-seek]'), time: m.querySelector('[data-dvr-time]'), vis: 0, userPaused: false, loaded: false };
    });
    cards.forEach(function (c) {
      all.push(c);
      c.v.muted = true;
      c.v.addEventListener('play', function () { c.m.classList.add('is-playing'); c.pp.setAttribute('aria-label', c.pp.getAttribute('data-pause-label')); });
      c.v.addEventListener('pause', function () { c.m.classList.remove('is-playing'); c.m.classList.add('is-ctl'); c.pp.setAttribute('aria-label', c.pp.getAttribute('data-play-label')); });
      c.v.addEventListener('volumechange', function () { updateSound(c); });
      c.v.addEventListener('timeupdate', function () { paint(c); });
      c.v.addEventListener('loadedmetadata', function () { paint(c); });
      c.pp.addEventListener('click', function (e) {
        e.stopPropagation();
        if (c.v.paused) play(c, true); else pause(c, true);
      });
      c.snd.addEventListener('click', function (e) {
        e.stopPropagation();
        var on = c.v.muted;
        if (on) all.forEach(function (o) { if (o !== c) { o.v.muted = true; updateSound(o); } });
        c.v.muted = !on;
        updateSound(c);
        if (on && c.v.paused) play(c, true);
        showCtl(c);
      });
      c.m.addEventListener('click', function (e) {
        if (e.target.closest('button, input')) return;
        if (c.v.paused && !c.loaded) { play(c, true); return; }
        if (c.m.classList.contains('is-ctl') && !c.v.paused) { c.m.classList.remove('is-ctl'); clearTimeout(c.ctlT); }
        else showCtl(c);
      });
      c.seek.addEventListener('input', function () {
        c.seeking = true;
        attach(c);
        var d = c.v.duration;
        if (d > 0) { c.v.currentTime = (c.seek.value / 1000) * d; }
        c.seek.style.setProperty('--p', (c.seek.value / 10) + '%');
        showCtl(c);
      });
      c.seek.addEventListener('change', function () { c.seeking = false; showCtl(c); });
      ['pointerup', 'touchend'].forEach(function (ev) { c.seek.addEventListener(ev, function () { c.seeking = false; }, { passive: true }); });
    });
    /* play the card that is most in view (60% or more); others pause */
    function decide() {
      if (document.hidden) return;
      var best = null;
      cards.forEach(function (c) { if (c.vis >= 0.6 && (!best || c.vis > best.vis)) best = c; });
      cards.forEach(function (c) {
        if (c === best) { if (c.v.paused && !c.userPaused && !reduce && !saveData) play(c, false); }
        else if (!c.v.paused) c.v.pause();
      });
    }
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { var c = cards.filter(function (x) { return x.m === en.target; })[0]; if (c && !reduce && !saveData) attach(c); } });
      }, { rootMargin: '300px 300px' });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { var c = cards.filter(function (x) { return x.m === en.target; })[0]; if (c) c.vis = en.isIntersecting ? en.intersectionRatio : 0; });
        decide();
      }, { threshold: [0, 0.3, 0.6, 0.8, 1] });
      cards.forEach(function (c) { near.observe(c.m); io.observe(c.m); });
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) cards.forEach(function (c) { if (!c.v.paused) c.v.pause(); }); else decide(); });
    /* dots and desktop arrows */
    var dots = [].slice.call(sec.querySelectorAll('.dvr__dot'));
    var navs = [].slice.call(sec.querySelectorAll('[data-dvr-nav]'));
    function step() { var f = rail && rail.querySelector('.dvr-card'); return f ? f.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 12) : 300; }
    function onScroll() {
      if (!rail) return;
      var i = Math.round(rail.scrollLeft / step());
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === Math.min(i, dots.length - 1)); });
      var max = rail.scrollWidth - rail.clientWidth - 4;
      navs.forEach(function (b) { b.disabled = b.getAttribute('data-dvr-nav') === '-1' ? rail.scrollLeft <= 4 : rail.scrollLeft >= max; });
    }
    if (rail) { rail.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll, { passive: true }); onScroll(); }
    navs.forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: Number(b.getAttribute('data-dvr-nav')) * step(), behavior: reduce ? 'instant' : 'smooth' }); }); });
  }
  function init() { [].forEach.call(document.querySelectorAll('[data-dvr]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target && e.target.querySelector('[data-dvr]'); if (s) setup(s); });
})();
